export enum DaycareTabIds {
	IN_DAYCARE_TAB = 0,
	IN_WALLET_TAB = 1,
}

export enum DaycarePageIds {
	IN_MINT_TAB = 0,
	IN_DAYCARE_TAB = 1,
}
